import { render, staticRenderFns } from "./ImageThumbnail.vue?vue&type=template&id=e145f1a4&"
import script from "./ImageThumbnail.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ImageThumbnail.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports